import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class PortabilityDatesService {

  constructor(private apiService: ApiService) {}

  /**
   * Portability dates
   */
  get() {
    return this.apiService.get<Array<string>>('vitrine/portability/dates');
  }
}
